import { NavBar } from "../Navbar/NavBar";
import axios from "axios";
import { React, Fragment, useState, useEffect } from "react";
import { Menu, Transition } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./retail.css";
import { ClipLoader } from "react-spinners";
import Select from "react-select";
import Sidebar from "../Sidebar";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const RetailLedDistributors = () => {
  const [activeTab, setActiveTab] = useState("lendingPartner");
  const [allChecked, setAllChecked] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [checkedOrders, setCheckedOrders] = useState({});
  const [selectedPartner, setSelectedPartner] = useState("");
  const [selectedMenuItems, setSelectedMenuItems] = useState({});
  const [selectedMenuItemsTotalCP, setSelectedMenuItemsTotalCP] = useState({});
  const [grids, setGrids] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [aggregatedOrders, setAggregatedOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleViewClick = (gridId) => {
    navigate(`/distributors-lead-retail/grid/${gridId}`);
  };
  const handleViewClick1 = (gridId) => {
    navigate(`/distributors-lead-retail/view-grid/${gridId}`);
  };

  const fetchOrders = async (searchQuery, start, length) => {
    setLoading(true);

    let url = "/workflow/api/orders/retailers";
    let queryParams = "";

    if (searchQuery) {
      const parsedQuery = parseInt(searchQuery, 10);
      if (!isNaN(parsedQuery)) {
        queryParams = `?search=true&order_id=${parsedQuery}`;
      } else {
        queryParams = `?search=true&buyer_name=${encodeURIComponent(
          searchQuery
        )}`;
      }
    }

    if (start != null && length != null) {
      if (queryParams === "") {
        queryParams += `?start=${start}&length=${length}`;
      } else {
        queryParams += `&start=${start}&length=${length}`;
      }
    }

    url += queryParams;

    const token = localStorage.getItem("token");
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (data.status && data.orders) {
      setOrders(data.orders);
      setTotalOrders(data.count);
    } else {
      setOrders([]); // Set orders to an empty array if there are no orders
    }
    setLoading(false);
  };

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchQuery(value);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchOrders(searchQuery);
    }, 800);
    return () => clearTimeout(timeout);
  }, [searchQuery]);

  const sendGridData = async () => {
    setLoading(true);

    const selectedOrders = Object.entries(selectedMenuItems).map(
      ([order_id, lending_partner]) => ({
        order_id: parseInt(order_id, 10),
        lending_partner,
        total_cp: selectedMenuItemsTotalCP[order_id],
      })
    );

    if (selectedOrders.length === 0) {
      toast.error("Please select at least one order.");
      setLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`/workflow/api/retailers/grids`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ orders: selectedOrders }),
      });

      const data = await response.json();
      console.log(data);

      if (response.ok) {
        toast.success("Grids created successfully!", { autoClose: 1000 });
        setTimeout(() => {
          setActiveTab("sourcingPartner");
        }, 2000);
      } else {
        toast.error("Failed to update grids!");
      }
    } catch (error) {
      toast.error("An error occurred while updating grids!");
    }

    setSelectedMenuItems({});
    await fetchOrders();
    setLoading(false);
    setTimeout(() => {
      setLoading(false);
    }, 3000 + Math.random() * 2000);
  };

  const handleAllOrdersChecked = (checked) => {
    const newCheckedOrders = {};
    orders.forEach((order) => {
      newCheckedOrders[order.order_id] = checked;
    });
    setCheckedOrders(newCheckedOrders);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const formatDate = (dateString) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const nth = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    const date = new Date(dateString);

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return `${day}${nth(day)} ${monthNames[monthIndex]} ${year}`;
  };

  const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const fetchGrids = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get("/workflow/api/retailers/grids", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.status) {
        setGrids(response.data.grids.rows);
      }
    } catch (error) {
      console.error("Failed to fetch grids:", error);
    }
  };

  useEffect(() => {
    if (activeTab === "sourcingPartner") {
      fetchGrids();
    }
    if (activeTab === "aggregatedorders") {
      fetchData();
    }
  }, [activeTab]);

  const fetchData = async () => {
    const token = localStorage.getItem("token");
    let url = "/workflow/api/retailers/grids/order_placed";

    // Append the search query if it exists
    if (searchQuery) {
      url += `?id=${encodeURIComponent(searchQuery)}`;
    }

    const result = await axios(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setAggregatedOrders(result.data.grids.rows);
  };

  const options = [
    { value: "Ayekart", label: "Ayekart" },
    { value: "Siply", label: "Siply" },
  ];

  const handleDeselectOrder = (orderId) => {
    const newMenuItems = { ...selectedMenuItems };
    const newTotalCP = { ...selectedMenuItemsTotalCP };

    delete newMenuItems[orderId];
    delete newTotalCP[orderId];

    setSelectedMenuItems(newMenuItems);
    setSelectedMenuItemsTotalCP(newTotalCP);
  };

  const handleLendingPartnerSelection = (
    selectedOption,
    orderId,
    orderAmount
  ) => {
    if (selectedOption) {
      setSelectedMenuItems({
        ...selectedMenuItems,
        [orderId]: selectedOption.value,
      });
      setSelectedMenuItemsTotalCP({
        ...selectedMenuItemsTotalCP,
        [orderId]: orderAmount,
      });
    } else {
      const newMenuItems = { ...selectedMenuItems };
      const newTotalCP = { ...selectedMenuItemsTotalCP };

      delete newMenuItems[orderId];
      delete newTotalCP[orderId];

      setSelectedMenuItems(newMenuItems);
      setSelectedMenuItemsTotalCP(newTotalCP);
    }
  };

  const ayekartOrders = [];
  const siplyOrders = [];

  Object.keys(selectedMenuItems).forEach((orderId) => {
    const lendingPartner = selectedMenuItems[orderId];
    if (lendingPartner === "Ayekart") {
      ayekartOrders.push(orderId);
    } else if (lendingPartner === "Siply") {
      siplyOrders.push(orderId);
    }
  });

  const pageSize = 10;
  const goToPreviousPage = (e) => {
    e.preventDefault();
    if (currentPage > 1) {
      const previousPage = currentPage - 1;
      const start = (previousPage - 1) * pageSize;
      setCurrentPage(previousPage);
      fetchOrders(searchQuery, start, pageSize);
    }
  };

  // Handle click event for next page
  const goToNextPage = (e) => {
    e.preventDefault();
    const totalPages = Math.ceil(totalOrders / pageSize);
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      const start = (nextPage - 1) * pageSize;
      setCurrentPage(nextPage);
      fetchOrders(searchQuery, start, pageSize);
    }
  };

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(totalOrders / pageSize);
  const maxVisiblePages = 5;
  let startPage = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
  let endPage = startPage + maxVisiblePages - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(endPage - maxVisiblePages + 1, 1);
  }

  const pageNumbers = Array.from(
    { length: endPage - startPage + 1 },
    (_, index) => startPage + index
  );

  const handlePageClick = (event, page) => {
    event.preventDefault();
    const start = (page - 1) * pageSize;
    setCurrentPage(page);
    fetchOrders(searchQuery, start, pageSize);
  };

  return (
    <div className="flex">
      <div className="mt-1 ml-8 builk-main ">
        {loading ? (
          <div className="fixed top-0 left-0 right-0 bottom-0 bg-gray-900 bg-opacity-50 flex items-center justify-center">
            <ClipLoader color="#4A1AC7" size={50} />
          </div>
        ) : null}
        {/*------------------------------------------- Tabs List Started --------------------------------------- */}
        <ToastContainer />
        <div className="py-4 px-4 md:px-8 dark:bg-gray-900 mt-10 flex justify center">
          <ul
            role="tablist"
            className="hidden max-w-screen-xl mx-auto px-2.5 items-center gap-x-3 overflow-x-auto text-sm bg-gray-50 dark:bg-slate-800 rounded-lg sm:flex"
          >
            <li className="py-2">
              <button
                role="tab"
                className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                  activeTab === "lendingPartner"
                    ? "text-white bg-dark shadow-sm"
                    : "text-gray-500 dark:text-gray-300"
                }`}
                onClick={() => setActiveTab("lendingPartner")}
              >
                Lending Partner To Assign
              </button>
            </li>
            <li className="py-2 ">
              <button
                role="tab"
                className={`py-2.5 px-4 rounded-lg duration-150 font-medium ${
                  activeTab === "sourcingPartner"
                    ? "text-white bg-dark shadow-sm"
                    : "text-gray-500 dark:text-gray-300"
                }`}
                onClick={() => setActiveTab("sourcingPartner")}
              >
                Grid List
              </button>
            </li>
            <li className="py-2 ">
              <button
                role="tab"
                className={`py-2.5 px-4 rounded-lg duration-150 font-medium ${
                  activeTab === "aggregatedorders"
                    ? "text-white bg-dark shadow-sm"
                    : "text-gray-500 dark:text-gray-300"
                }`}
                onClick={() => setActiveTab("aggregatedorders")}
              >
                Aggregated Orders List
              </button>
            </li>
          </ul>
        </div>
        <div className="flex items-center justify-center px-5"></div>

        {/*------------------------------------------- Tabs List Ended --------------------------------------- */}

        {/*------------------------------------------- Lending Partner Starts --------------------------------------- */}
        {activeTab === "lendingPartner" && (
          <div className="text-gray-500 p-2 ">
            <section className="fluid w-full px-2">
              <div className="flex items-right justify-end space-x-5">
                {/* Search input */}
                <input
                  className="shadow-lg shadow-cyan-500/50 rounded-md w-100 h-10 mt-8 border border-gray-300 py-2 px-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-50 dark:focus:ring-gray-400 dark:focus:ring-offset-gray-900"
                  type="text"
                  placeholder="Search By Order Id or Buyer Name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                {/* Selected orders count and submit button */}
                <div className="flex justify-end mt-4 space-x-4">
                  <div className="text-gray-700">
                    Selected Orders:
                    <span className="font-semibold ml-1">
                      {Object.keys(selectedMenuItems).length}
                    </span>
                  </div>
                  <button
                    onClick={sendGridData}
                    className="w-40 rounded-md bg-indigo-600 px-3.5 py-1.5 text-base font-semibold leading-7 text-white hover:bg-indigo-500"
                  >
                    Submit
                  </button>
                </div>
              </div>
              {/* Selected Order IDs */}
              {Object.keys(selectedMenuItems).length > 0 && (
                <div className="mt-4 p-4 bg-gray-100 rounded-md">
                  <h3 className="text-lg font-semibold text-gray-800">
                    Selected Order IDs:
                  </h3>
                  {ayekartOrders.length > 0 && (
                    <div className="mt-2">
                      <h4 className="text-base font-semibold text-gray-600">
                        Ayekart Orders:
                      </h4>
                      <div className="space-x-1">
                        {ayekartOrders.map((orderId) => (
                          <span
                            key={orderId}
                            className="inline-flex items-center px-3 py-1 text-sm font-medium bg-blue-100 text-blue-800 rounded-full cursor-pointer"
                            onClick={() => handleDeselectOrder(orderId)}
                          >
                            {orderId}
                            <svg
                              className="w-3 h-3 ml-1 text-blue-500"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                  {siplyOrders.length > 0 && (
                    <div className="mt-2">
                      <h4 className="text-base font-semibold text-gray-600">
                        Siply Orders:
                      </h4>
                      <div className="space-x-1">
                        {siplyOrders.map((orderId) => (
                          <span
                            key={orderId}
                            className="inline-flex items-center px-3 py-1 text-sm font-medium bg-green-100 text-green-800 rounded-full cursor-pointer"
                            onClick={() => handleDeselectOrder(orderId)}
                          >
                            {orderId}
                            <svg
                              className="w-3 h-3 ml-1 text-green-500"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Orders table */}
              <div className="flex flex-col mt-2">
                <div className="overflow-x-auto bg-cyan-500 shadow-lg shadow-cyan-500/50">
                  <div className="inline-block min-w-full py-2 align-middle bg-cyan-500 shadow-lg shadow-cyan-500/50">
                    <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg bg-cyan-500 shadow-lg shadow-cyan-500/50">
                      <div className="table-container">
                        <table className="min-w-full bg-cyan-500 shadow-lg shadow-cyan-500/50">
                          <thead className="bg-gray-50 dark:bg-gray-800 ">
                            <tr className="divide-x">
                              <th
                                scope="col"
                                className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-white"
                              >
                                <span>Order Id</span>
                              </th>
                              <th
                                scope="col"
                                className="rounded-md bg-gray-900 px-12 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                              >
                                Ordered Date
                              </th>
                              <th
                                scope="col"
                                className="rounded-md bg-gray-900 px-4 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                              >
                                Buyer Name
                              </th>
                              <th
                                scope="col"
                                className="rounded-md bg-gray-900 px-4 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                              >
                                Seller Name
                              </th>
                              <th
                                scope="col"
                                className="rounded-md bg-gray-900 px-4 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                              >
                                Order Amount
                              </th>
                              <th
                                scope="col"
                                className="rounded-md bg-gray-900 px-4 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                              >
                                Lending Partner
                              </th>
                            </tr>
                          </thead>

                          {/* Table body */}
                          <tbody className="bg-white dark:bg-gray-900 overflow-y-auto">
                            {orders.map((order) => (
                              <tr key={order.id} className="divide-x">
                                <td className="py-4 px-4 whitespace-nowrap text-center rounded-md">
                                  <div className="text-sm font-medium text-gray-900 dark:text-white">
                                    {order.order_id}
                                  </div>
                                </td>
                                <td className="px-12 py-4 whitespace-nowrap text-center rounded-md">
                                  <div className="text-sm text-gray-900 dark:text-white">
                                    {formatDate(order.order_placed_date)}
                                  </div>
                                </td>
                                <td className="px-12 py-4 whitespace-nowrap text-center rounded-md">
                                  <div className="text-sm text-gray-900 dark:text-white">
                                    {order.buyer_name}
                                  </div>
                                </td>
                                <td className="px-12 py-4 whitespace-nowrap text-center rounded-md">
                                  <div className="text-sm text-gray-900 dark:text-white">
                                    {order.seller_name}
                                  </div>
                                </td>
                                <td className="px-12 py-4 whitespace-nowrap text-center rounded-md">
                                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-bold bg-green-100 text-green-800">
                                    {` ₹ ${formatNumberWithCommas(
                                      order.amount
                                    )}`}
                                  </span>
                                </td>
                                <td className="px-12 py-4 whitespace-nowrap text-center rounded-md">
                                  <Select
                                    value={
                                      selectedMenuItems[order.order_id]
                                        ? {
                                            value:
                                              selectedMenuItems[order.order_id],
                                            label:
                                              selectedMenuItems[order.order_id],
                                          }
                                        : null
                                    }
                                    onChange={(selectedOption) =>
                                      handleLendingPartnerSelection(
                                        selectedOption,
                                        order.order_id,
                                        order.amount
                                      )
                                    }
                                    options={options}
                                    isSearchable={false}
                                    isClearable={true}
                                    className={`p-3 float-left inline-flex items-center justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm ring-gray-300 ${
                                      selectedMenuItems[order.order_id] ===
                                      "Ayekart"
                                        ? "bg-blue-500 text-dark"
                                        : selectedMenuItems[order.order_id] ===
                                          "Siply"
                                        ? "bg-green-500 text-dark"
                                        : "bg-white text-gray-900"
                                    }`}
                                    menuPortalTarget={document.body}
                                    menuPosition={"fixed"}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>

                          {/* Table footer */}
                          {!loading && searchQuery && orders.length === 0 && (
                            <tfoot>
                              <tr>
                                <td colSpan={6} className="text-center py-4">
                                  <span className="text-lg font-semibold text-gray-500">
                                    No orders found
                                  </span>
                                </td>
                              </tr>
                            </tfoot>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              <div className="flex items-center justify-center pt-6 pb-6">
                <a
                  href="#"
                  className={`mx-1 cursor-pointer text-xl font-semibold text-gray-900 ${
                    currentPage === 1 ? "cursor-not-allowed" : ""
                  }`}
                  onClick={goToPreviousPage}
                >
                  <span className="hidden lg:block">← Previous</span>
                  <span className="block lg:hidden">←</span>
                </a>
                {pageNumbers.map((page) => (
                  <a
                    key={page}
                    href="#"
                    className={`mx-1 flex items-center rounded-md border  text-lg  border-gray-400 px-3 py-1 text-gray-900 hover:scale-105 ${
                      page === currentPage ? "bg-gray-900 text-white" : ""
                    }`}
                    onClick={(e) => handlePageClick(e, page)}
                  >
                    {page}
                  </a>
                ))}
                <a
                  href="#"
                  className={`mx-2 text-xl  font-semibold text-gray-900 ${
                    currentPage === totalPages ? "cursor-not-allowed" : ""
                  }`}
                  onClick={goToNextPage}
                >
                  <span className="hidden lg:block">Next →</span>
                  <span className="block lg:hidden">→</span>
                </a>
              </div>
            </section>
          </div>
        )}

        {/*------------------------------------------- Lending Partner Ends--------------------------------------- */}

        {/*------------------------------------------- Grid Lists Starts--------------------------------------- */}

        {activeTab === "sourcingPartner" && (
          <div className="text-gray-500">
            <section className="fluid w-full  px-2">
              <div className="flex items-center justify-between"></div>
              <div className="flex flex-col mt-2 ">
                <div className="overflow-x-auto bg-cyan-500 shadow-lg shadow-cyan-500/50 ">
                  <div className="inline-block min-w-full py-2 align-middle bg-cyan-500 shadow-lg shadow-cyan-500/50">
                    <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg bg-cyan-500 shadow-lg shadow-cyan-500/50">
                      <table className="min-w-full bg-cyan-500 shadow-lg shadow-cyan-500/50 ">
                        <thead className="bg-gray-50 dark:bg-gray-800">
                          <tr className="divide-x divide-gray-200">
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-white"
                            >
                              <span>Grid Id</span>
                            </th>

                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-white"
                            >
                              Created Date
                            </th>

                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                            >
                              Number Of Orders
                            </th>
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                            >
                              Grid Status
                            </th>
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                          {grids.map((grid) => (
                            <tr
                              key={grid.id}
                              className="divide-x divide-gray-200"
                            >
                              <td className="py-4 px-4 whitespace-nowrap text-center">
                                <div className="flex items-center justify-center">
                                  <div className="text-sm text-gray-500 dark:text-gray-300">
                                    {grid.id}
                                  </div>
                                </div>
                              </td>
                              <td className="px-12 py-4 whitespace-nowrap text-center">
                                <div className="text-sm text-gray-900 dark:text-white">
                                  {formatDate(grid.created_at)}
                                </div>
                              </td>
                              <td className="px-4 py-4 whitespace-nowrap text-center">
                                {grid.total_orders}
                              </td>
                              <td className="py-4 px-4 whitespace-nowrap text-center">
                                <div className="flex items-center justify-center">
                                  <div
                                    className={`text-sm text-dark text-center px-2 py-1 rounded ${
                                      grid.grid_status === "Pending"
                                        ? "bg-yellow-300 text-yellow-800"
                                        : grid.grid_status === "Order Placed"
                                        ? "bg-green-300 text-green-800"
                                        : "bg-gray-300 text-gray-800"
                                    }`}
                                  >
                                    {grid.grid_status}
                                  </div>
                                </div>
                              </td>
                              <td className="px-4 py-4 whitespace-nowrap text-center">
                                <span
                                  className="inline-flex items-center justify-center text-sm leading-5 font-semibold rounded-full bg-blue-900 text-white px-4 py-2 cursor-pointer"
                                  onClick={() => handleViewClick(grid.id)}
                                >
                                  View
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        )}

        {/*------------------------------------------- Grid List Ends --------------------------------------- */}

        {/*------------------------------------------- Aggregated Orders Start--------------------------------------- */}
        {activeTab === "aggregatedorders" && (
          <div className="text-gray-500">
            <section className="fluid w-full  px-2">
              <div className="flex items-right justify-end space-x-5">
                {/* <input
                  className="shadow-lg shadow-cyan-500/50 rounded-md w-100 border border-gray-300 bg-transparent py-2 px-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-50 dark:focus:ring-gray-400 dark:focus:ring-offset-gray-900"
                  type="text"
                  placeholder="Search By Grid Id"
                /> */}
              </div>
              <div className="flex flex-col mt-2 ">
                <div className="overflow-x-auto bg-cyan-500 shadow-lg shadow-cyan-500/50 ">
                  <div className="inline-block min-w-full py-2 align-middle bg-cyan-500 shadow-lg shadow-cyan-500/50">
                    <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg bg-cyan-500 shadow-lg shadow-cyan-500/50">
                      <table className="min-w-full bg-cyan-500 shadow-lg shadow-cyan-500/50 ">
                        <thead className="bg-gray-50 dark:bg-gray-800">
                          <tr className="divide-x">
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-white"
                            >
                              <span>Grid Id</span>
                            </th>
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 px-12 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                            >
                              Order Placed
                            </th>{" "}
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 px-12 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                            >
                              Total Orders
                            </th>
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 px-4 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                            >
                              Total Amount
                            </th>
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 px-4 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                            >
                              Grid Status
                            </th>
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 px-4 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                            >
                              Action
                            </th>
                          </tr>
                        </thead>

                        <tbody className="bg-white dark:bg-gray-900">
                          {aggregatedOrders.map((order) => (
                            <tr className="divide-x" key={order.id}>
                              <td className="py-4 px-4 whitespace-nowrap text-center rounded-md">
                                <div className="text-sm font-medium text-gray-900 dark:text-white">
                                  {order.id}
                                </div>
                              </td>
                              <td className="px-12 py-4 whitespace-nowrap text-center rounded-md">
                                <div className="text-sm text-gray-900 dark:text-white">
                                  {formatDate(order.updated_at)}
                                </div>
                              </td>
                              <td className="px-12 py-4 whitespace-nowrap text-center rounded-md">
                                <div className="text-sm text-gray-900 dark:text-white">
                                  {order.total_orders}
                                </div>
                              </td>
                              <td className="px-12 py-4 whitespace-nowrap text-center rounded-md">
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-bold bg-green-100 text-green-800">
                                  {` ₹ ${formatNumberWithCommas(
                                    order.total_amount
                                  )}`}
                                </span>
                              </td>
                              <td className="py-4 px-4 whitespace-nowrap text-center">
                                <div className="flex items-center justify-center">
                                  <div
                                    className={`text-sm text-center px-2 py-1 rounded ${
                                      order.grid_status === "Pending"
                                        ? "bg-yellow-300 text-yellow-800"
                                        : order.grid_status === "Order Placed"
                                        ? "bg-green-300 text-green-800"
                                        : "bg-gray-300 text-gray-800"
                                    }`}
                                  >
                                    {order.grid_status}
                                  </div>
                                </div>
                              </td>
                              <td className="px-4 py-4 whitespace-nowrap text-center">
                                <span
                                  className="inline-flex items-center justify-center text-sm leading-5 font-semibold rounded-full bg-blue-900 text-white px-4 py-2 cursor-pointer"
                                  onClick={() => handleViewClick1(order.id)}
                                >
                                  View
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>

                        {orders.length === 0 && (
                          <tfoot>
                            <tr>
                              <td colSpan={7} className="text-center py-4">
                                <span className="text-lg font-semibold text-gray-500">
                                  No orders found
                                </span>
                              </td>
                            </tr>
                          </tfoot>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        )}
        {/*------------------------------------------- Aggregated Orders End--------------------------------------- */}
      </div>
    </div>
  );
};

export default RetailLedDistributors;
